import Api from "./Api";

class NavigationApi extends Api {
  static menu() {
    return this.get("navigation").then(res => {
      res.data.primary = res.data.primary.map(p => {
        if (!p.icon || p.icon === "") {
          switch (p.name || p.title) {
            case "Videos":
              p.icon = "play";
              break;
            case "Galleries":
              p.icon = "images";
              break;
            case "Images":
              p.icon = "image";
              break;
            case "Cams":
              p.icon = "video";
              break;
            case "Tags":
              p.icon = "tags";
              break;
            default:
              break;
          }
        }

        return p;
      });

      return res;
    });
  }
}

export default NavigationApi